import { getApiBaseUrl } from '@/lib/api-base-url';

// Best-effort revoke of the refresh token + cookie; the caller clears local state regardless, so a failure here is harmless.
export async function signOutRequest(): Promise<void> {
  try {
    await fetch(`${getApiBaseUrl()}/auth/sign-out`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // Ignore — local sign-out below is what the user sees; the token expires anyway.
  }
}
